var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.36524 11.1873C8.38125 11.2077 8.4017 11.2243 8.42505 11.2357C8.4484 11.247 8.47403 11.2529 8.5 11.2529C8.52597 11.2529 8.5516 11.247 8.57495 11.2357C8.5983 11.2243 8.61875 11.2077 8.63476 11.1873L11.0305 8.15626C11.1182 8.04503 11.039 7.88033 10.8957 7.88033H9.3107V0.641826C9.3107 0.547708 9.23369 0.470703 9.13957 0.470703H7.85615C7.76203 0.470703 7.68503 0.547708 7.68503 0.641826V7.87819H6.10428C5.96096 7.87819 5.88182 8.0429 5.96952 8.15413L8.36524 11.1873ZM16.3289 10.4386H15.0455C14.9513 10.4386 14.8743 10.5156 14.8743 10.6097V13.9039H2.12567V10.6097C2.12567 10.5156 2.04866 10.4386 1.95455 10.4386H0.671123C0.577005 10.4386 0.5 10.5156 0.5 10.6097V14.845C0.5 15.2236 0.805882 15.5295 1.18449 15.5295H15.8155C16.1941 15.5295 16.5 15.2236 16.5 14.845V10.6097C16.5 10.5156 16.423 10.4386 16.3289 10.4386Z",
    fill: "#2060EA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.fb589fbdc4977c7ddd4e63b36c5bed9c.svg";
export { ForwardRef as ReactComponent };